import { User } from "./user";

export enum SubscriptionType {
    Weekly = 'weekly',
    Daily = 'daily',
}

export interface SubscriptionParams {
    projectId: number;
    ownerId?: number;
    userId: number;
    type: SubscriptionType;
    subscriptionId?: number;
}

export interface UserWithSubscriptionType extends User {
    ProjectSubscriptions: SubscriptionParams[]
}
